import React, {useState, useEffect} from "react";
import Header from '../include/header';
import Footer from '../include/footer';
import LeftPanel from '../include/leftpanel';
import Global from "../../APIConfig";
import  axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import MainLoader from "../Loaders/MainLoader";
import ListLoader from "../Loaders/ListLoader";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Select from 'react-select';
import { Button } from "react-bootstrap";

function ScheduledPickupList(){
    let navigate = useNavigate();
    const [mainList, setMainList] = useState([]);   // original data
    const [list, setList] = useState([]);           // filtered data (UI shows this)
    const [Loading, setLoading] = useState(false); 
    const [SubLoading, setSubLoading] = useState(false); 
    const{headers1,headers2,logout}=AuthUser();
    const [selectedfromdate, setSelectedfromdate] = useState(getTodayDateString());
    const [selectedtodate, setSelectedtodate] = useState(getTodayDateString());
    const [selectedcustomer, setSelectedcustomer] = useState('');
    const [selectedWarehouse, setSelectedWarehouse] = useState('');
    const [customerlist, setCustomerlist] = useState([]);
    const [selectedType, setSelectedType] = useState('All'); // Default to 'All'
    const [messengerlist, setMessengerlist] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [selectedMessenger, setSelectedMessenger] = useState('');
    const [checkedItems, setCheckedItems] = useState([]); // State to manage checked items
    const [BtnLoading, setBtnLoading] = useState(false);
    const [hublist, setHublist] = useState([]);
    const [selectedHub, setSelectedHub] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('CF');
    const items = JSON.parse(localStorage.getItem('user'));
    const [countrylist, setCountrylist] = useState([]);
    const [citylist, setCitylist] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [defaulcountryname, setDefaulcountryname] = useState('');

     useEffect(()=>{
            GetCountrylist();
        },[]);

    // Function to get today's date in the format "YYYY-MM-DD"
    function getTodayDateString() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

    const GetCountrylist=()=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'Countrylist',
                data: {
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data.value;
                    setCountrylist(data);
                }
                setLoading(false);
              })
              .catch(function (error) {
                // console.log(error);
                setLoading(false);
              });
        }

    const handleCountryChange = (event) => {
        const countryname = event.target.value;
        setSelectedCountry(event.target.value);
        GetCityList(countryname);
    };

    const GetCityList=(val)=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'Citylist',
                data: {
                    name: val
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data.value;
                    setCitylist(data);
                }
                else
                {
                    setCitylist([]);
                }
              })
              .catch(function (error) {
                // console.log(error);
                // setLoading(false);
              });
        }
    // Handle city selection
    const handleCityChange = (event) => {
        const cityid = event.value;
        setSelectedCity(event.value);
        GetHubList(cityid);
        GetMessengerList(cityid);
        Getcustomerlist('C');
    };
    const GetMessengerList=(val)=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'Messengerlist',
                data: {
                    cityid: val
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data.value;
                    setMessengerlist(data);
                }
              })
              .catch(function (error) {
                // console.log(error);
                // setLoading(false);
              });
        }

    const GetHubList=(val)=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'Hublist',
                data: {
                    cityid: val
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data.value;
                    setHublist(data);
                }
              })
              .catch(function (error) {
                // console.log(error);
                // setLoading(false);
              });
        }

    const Getcustomerlist=(val)=>{
        setBtnLoading(true);
        setSelectedType(val);
        axios({
            method: 'post',
            url: Global.baseUrl+'CustomerAgentlistByType',
            headers:headers1,
            data: {
                type:val,
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCustomerlist(data);
                setBtnLoading(false);
            }
             else
            {
                toast.warn(response.data.message);
                setBtnLoading(false);
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                // logout();
                // navigate('/');
                // window.location.reload();
            }
            // console.log(error);
          });
    }

    const ShipmentDelete=(id)=>{
        if (window.confirm('Do You  want to delete ?')) {
            axios({
                method: 'post',
                url: Global.baseUrl+'SchedulepickupDelete',
                headers:headers1,
                data: {
                    sp_no:id
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                   toast.success(response.data.message);
                }
                else
                {
                    toast.warn(response.data.message);
                }
              })
              .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
              });
              Submitdata();
          } 
        //   else {
        //     Submitdata();
        //   }
        
    }

    const Submitdata=()=>
        {
            if(selectedCountry =="")
            {
                toast.error('Please Select Country');
                return;
            }
            if(selectedCity =="")
            {
                toast.error('Please Select City');
                return;
            }
             axios({
                 method: 'post',
                 url: Global.baseUrl+'Schedulepickuplist',
                 headers:headers1,
                 data: {
                     Fromdate:selectedfromdate,
                     Todate:selectedtodate,
                     cityid:selectedCity,
                 }
                 })
                 .then(function (response) {
                 if(response.data.status == 200)
                 {
                     toast.success(response.data.message);
                     const data = response.data.value.data;
                     setMainList(data);   
                     setList(data);
                 }
                 else{
                     toast.warn(response.data.message);
                 }
                 })
                 .catch(function (error) {
                 if(error.response.status==401){
                     toast.error(error.response.statusText);
                     logout();
                     navigate('/');
                     window.location.reload();
                 }
                 // console.log(error);
                 });
         }

    const handleCustomerChange=(val)=>{
        if (!val) {
            setList(mainList); // reset filter
            return;
        }
        setBtnLoading(true);
        axios({
                method: 'post',
                url: Global.baseUrl+'Warehousenamebyschedulepickup',
                headers:headers1,
                data: {
                    custid:val
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    setWarehouseList(response.data.value);
                    setBtnLoading(false);
                }
                else{
                    toast.warn(response.data.message);
                    setBtnLoading(false);
                }
              })
              .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
              });
        setSelectedcustomer(val);
            setList(mainList);
        const filtered = mainList.filter(
            (item) => String(item.cust_id) === String(val)
        );

        setList(filtered);
    }

    
    const handleWarehouseChange=(val)=>{
        if (!val) {
            setList(list); // reset filter
            return;
        }
        setSelectedWarehouse(val);
        const filtered = mainList.filter(
            (item) => String(item.warehouseid) === String(val)
        );

        setList(filtered);
    }

    // Handle Hub selection
    const handleMessengerChange = (event) => {
        setSelectedMessenger(event.value);
    };

        const isChecked = (sp_id) => checkedItems.includes(sp_id);

        const handleChange = (event) => {
        const sp_id = event.target.value;
        if(!checkedItems.includes(sp_id)){
            setCheckedItems([...checkedItems,sp_id]);
        }else{
            let arr=checkedItems.filter((item)=>item!==sp_id);
            setCheckedItems(arr);
        }
        
      };

    const Submitpickup=()=>{
        if(selectedHub == ''){
            toast.warn('Please select hub.');
            return;
        }
        if(selectedMessenger == ''){
            toast.warn('Please select messenger (Driver).');
            return;
        }
        if(checkedItems.length <= 0){
            toast.warn('Please select at least one shipment.');
            return;
        }
            setBtnLoading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'UpdateSchedulepickupmessanger',
                headers:headers1,
                data: {
                    sp_id:checkedItems,
                    messenger:selectedMessenger,
                    hubid:selectedHub,
                    status:selectedStatus
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                    setBtnLoading(false);
                    setCheckedItems([]);
                    setTimeout(() => {
                        navigate('/ScheduledPickupList');
                        window.location.reload();
                    }, 1000);
                }
                else{
                    toast.warn(response.data.message);
                    setBtnLoading(false);
                }
              })
              .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
              });
    }

    // Handle Hub selection
    const handleHubChange = (event) => {
        setSelectedHub(event.value);
    };


    
    const GetStatusName =($type) =>
    { 
        if($type=='P')
        {
        return  '<span className="status pickedup">Pending</span>';
        }
        if($type=='CF')
        {
        return  '<span className="status pickup_sechdls">Confirmed</span>';
        }
        if($type=='PD')
        {
        return  '<span className="status pickedup"><i className="fa fa-check" aria-hidden="true"></i> Picked-up</span>';
        }
        if($type=='CT')
        {
        return  '<span className="status delivered"><i className="fa fa-check-circle" aria-hidden="true"></i> Complete</span>';
        } 
        if($type=='R')
        {
        return  '<span className="status pickup_sechdls">Reschedule Pickup</span>';
        
        }
        if($type=='PC')
        {
        return  '<span className="status cancelled">Cencal Pickup</span>';
        
        }
    }

return(
    <>
        <LeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer/>
            {Loading==true ? <MainLoader/> :
            <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Schedule Shipments</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">All Schedule Shipments</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card mb-3">
              <div className="card-body">
                <div className="row">
                    <div className="col-12 col-md-2 mb-3">
                        <div><label htmlFor="email" className="form-label">From Date: <span className="text-danger"></span></label></div>
                        <input type="date" className="form-control" id="text" value={selectedfromdate} placeholder="Enter city name" onChange={(e)=>setSelectedfromdate(e.target.value)}/>
                    </div>
                    <div className="col-12 col-md-2 mb-3">
                        <div><label htmlFor="email" className="form-label">To Date: <span className="text-danger"></span></label></div>
                        <input type="date" className="form-control" id="text" value={selectedtodate} placeholder="Enter city name" onChange={(e)=>setSelectedtodate(e.target.value)}/>
                    </div>
                    <div className="col-12 col-md-3 mb-3">
                        <div><label htmlFor="email" className="form-label">Select Country: <span className="text-danger">*</span></label></div>
                        <select className="form-select" onChange={handleCountryChange}>
                            <option value="">-- Please Select --</option>
                            {countrylist.map((list,i)=>{
                            return (
                            <option value={list.country} selected={defaulcountryname == list.country} key={i}>{list.country}</option>
                            );
                            })}
                        </select>
                    </div>
                    <div className="col-12 col-md-3 mb-3">
                        <div><label htmlFor="email" className="form-label">Select City: <span className="text-danger">*</span></label></div>
                        <Select
                        onChange={handleCityChange}
                        options={citylist} 
                        placeholder="Enter city name"
                        />
                    </div>
                    {/* <div className="col-12 col-md-4 mb-3">
                        <div><label htmlFor="email" className="form-label">Select User Type: <span className="text-danger"></span></label></div>
                        <select className="form-select" onChange={(e)=>Getcustomerlist(e.target.value)}>
                            <option value="">-- Please Select --</option>
                            <option value="C">Customer</option>
                            <option value="A">Agent</option>
                        </select>
                    </div> */}
                    <div className="col-12 col-md-2 mb-3 mt-2">
                        <div><label htmlFor="email" className="form-label"> <span className="text-danger"></span></label></div>
                    <button onClick={()=>Submitdata()} className="btn btn-primary">Fetch Reports</button>
                    </div>
                </div>
              </div>
            </div>
            <section className="data_table">
                <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                    <div className=" d-flex justify-content-end">
                        <div className="col-12 col-md-3 mb-3 p-2">
                            <div><label htmlFor="email" className="form-label">Select Customer: <span className="text-danger"></span></label></div>
                            <select className="form-select" onChange={(e)=>handleCustomerChange(e.target.value)}>
                                <option value="">-- Please Select --</option>
                                {customerlist.map((cust,i)=>{
                                    return(
                                    <option value={cust.value} key={i}>{cust.label}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="col-12 col-md-3 mb-3 p-2">
                            <div><label htmlFor="email" className="form-label">Select Warehouse: <span className="text-danger"></span></label></div>
                            <select className="form-select" onChange={(e)=>handleWarehouseChange(e.target.value)}>
                                <option value="">-- Please Select --</option>
                                {warehouseList.map((war,i)=>{
                                    return(
                                    <option value={war.unique_id} key={i}>{war.warehouseName}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="col-12 col-md-3 mb-3 p-2">
                            <div className="d-flex justify-content-between">
                                <div ><label htmlFor="email" className="form-label">Select HUB: <span className="text-danger">*</span></label> </div>
                            </div>
                            <Select
                            onChange={handleHubChange}
                            options={hublist} 
                            placeholder="Select Hub"
                            />
                        </div>
                        <div className="col-12 col-md-3 mb-3 p-2">
                            <div className="d-flex justify-content-between">
                                <div ><label htmlFor="email" className="form-label">Select Messenger (Driver): <span className="text-danger">*</span></label> </div>
                            </div>
                            <Select
                            onChange={handleMessengerChange}
                            options={messengerlist} 
                            placeholder="Select Messanger"
                            />
                        </div>
                        {/* <div className="col-12 col-md-4 mb-3 p-2">
                            <div className="d-flex justify-content-between">
                                <div ><label htmlFor="email" className="form-label">Select Status: <span className="text-danger">*</span></label> </div>
                            </div>
                            <select className="form-control" onChange={(e)=>setSelectedStatus(e.target.value)}>
                                <option value="">Select Please</option>
                                <option value="P">Pending</option>
                                <option value="CF">Confirmed</option>
                                <option value="PD">Picked up</option>
                                <option value="PC">Picked cancel</option>
                                <option value="CT">Complete</option>
                                <option value="R">Reschedule Pickup</option>
                            </select>
                        </div> */}
                    </div>
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <td></td>
                                <th className="border-gray-200">Schedule Unique ID</th>
                                <th className="border-gray-200">Warehoues Id</th>
                                <th className="border-gray-200">Name</th>
                                <th className="border-gray-200">Address</th>
                                <th className="border-gray-200">Pickup Date</th>
                                <th className="border-gray-200">Pickup Time</th>
                                <th className="border-gray-200">Status</th>
                                <th className="border-gray-200">Action</th>
                            </tr>
                        </thead>
                        {SubLoading==true? <tbody><tr><td colSpan={9}><ListLoader/></td></tr></tbody> : 
                            <tbody>
                                {list.length > 0 ? 
                                    <>
                                    {list.map((ship,index)=>{
                                        return(
                                    <tr key={index}>
                                        <td style={{"width": "20px"}}>
                                            <input className="form-check-input" type="checkbox" value={ship.sp_id} checked={isChecked(ship.sp_id)} onChange={handleChange} />
                                        </td>
                                        <td style={{"width": "20px"}}>
                                            <span className="fw-bold">{ship.sp_id}</span>
                                            <CopyToClipboard text={ship.sp_id} onCopy={()=>{toast.success(ship.sp_id+' Copied To Clipboard')}}><i className="bx bx-copy"></i></CopyToClipboard>
                                        </td>
                                        <td>
                                            <span className="fw-normal text-capitalize">{ship.warehouseid}</span>
                                        </td>
                                       <td>
                                        <span className="fw-normal text-capitalize">{ship.name}</span>
                                        </td>
                                        <td><span className="fw-normal text-capitalize">{ship.pickup_location}</span></td>
                                        <td><span className="fw-normal text-capitalize">{ship.pickup_date}</span></td>
                                        <td><span className="fw-normal text-capitalize">{ship.pickup_time}</span></td>
                                        <td><span dangerouslySetInnerHTML={{__html:GetStatusName(ship.aps_status)}}></span></td>
                                        <td>
                                            {/* <Link to={`/CourierBarcode/${ship.sp_id}/${ship.cust_id}`} target="_blank" className="btn btn-gray-100 btn-sm" data-bs-toggle="tooltip" title="List of Shipments"><i className="bx bx-barcode"></i></Link> */}
                                            <Link to={`/CustomerScheduledPickupList/${ship.sp_id}/${ship.cust_id}`} target="_blank" className="btn btn-gray-100 btn-sm" data-bs-toggle="tooltip" title="List of Shipments"><i className="bx bx-box"></i></Link>
                                            <button className="btn btn-gray-100 btn-sm" data-bs-toggle="tooltip" title="Delete" onClick={()=>ShipmentDelete(ship.sp_id)}><i className="bx bx-x"></i></button>
                                        </td>
                                    </tr> 
                                    );
                                })}   
                                    </>
                                :
                                    <tr>
                                        <td colSpan="9" className="text-center">Record Not Found</td>
                                    </tr>
                                }                    
                            </tbody>
                        }
                    </table>
                    
                </div>
            </section>
            {BtnLoading==false?
            <div className="d-grid col-md-2 mt-2">
                <Button onClick={Submitpickup} className="btn btn-primary">Generate Schedule Pickup</Button>
            </div>
            :
            <div className="d-grid col-md-2 mt-2">
                <a href="" className="btn btn-primary btn-block"> <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading...</span></div></a>
            </div>
            }
            </>
            }
            <Footer/>
        </main>
    </>
);
}
export default ScheduledPickupList;